import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.scss';

const Header = ({ title, headerClickable, toggleOpen }) => (
  <div
    className={styles['collapsible-bar']}
    onClick={headerClickable ? toggleOpen : null}
    onKeyDown={headerClickable ? toggleOpen : null}
    role="menubar"
    tabIndex="0"
  >
    <div className={styles.title}>
      <p>{title}</p>
    </div>
    <div className={styles.header}>
      <button className={styles.button} onClick={toggleOpen} disabled={headerClickable} type="button">
        <i className="fal fa-angle-down" />
      </button>
    </div>
  </div>
);

Header.propTypes = {
  title: PropTypes.string.isRequired,
  headerClickable: PropTypes.bool,
  toggleOpen: PropTypes.func.isRequired,
};

Header.defaultProps = {
  headerClickable: false,
};

export default Header;
